export default __webpack_public_path__ + "static/media/download.698e07b6.svg";